class WishlistToastNotification extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.handleShowToastNotification =
      this.handleShowToastNotification.bind(this)

    this.handleClose = this.handleClose.bind(this)
    this.handleStartCloseFunction = this.handleStartCloseFunction.bind(this)
    this.handleStopCloseFunction = this.handleStopCloseFunction.bind(this)

    this.externalEls.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleShowToastNotification)
    })

    this.listeners.add(
      this.externalEls.trigger.element,
      'click',
      this.handleShowToastNotification,
    )

    this.listeners.add(this.els.close.element, 'click', this.handleClose)
    this.listeners.add(this, 'mouseover', this.handleStopCloseFunction)
    this.listeners.add(this, 'mouseout', this.handleStartCloseFunction)
  }

  handleShowToastNotification () {
    window._swat.evtLayer.addEventListener(
      window._swat.JSEvents.addedToWishlist,
      (data) => {
        const productTitle = data.detail.d.dt
        const productImage = data.detail.d.iu

        const listConfig = {
          lid: data.detail.d.lid,
        }

        const onSuccess = (listDetails) => {
          this.listName = listDetails.list.lname

          this.els.media.element.innerHTML = `<div class="rsp-Image"><img class="rsp-Image_Image" src="${productImage}" alt="${productTitle}"></div>`
          this.els.title.element.innerHTML = `${productTitle} ${window.theme.wishlist.hasBeenAddedTo} ${this.listName} ${window.theme.wishlist.successfully}. <span class="wsh-ToastNotificationProduct_WishlistLink">${window.theme.wishlist.viewWishlist}</span>`
        }

        const onError = (error) => {
          this.handleClose()

          /* eslint-disable-next-line no-console */
          console.log('Error while fetching List details', error)
        }

        window._swat.fetchListDetails(listConfig, onSuccess, onError)

        this.setAttribute('aria-hidden', 'false')

        this.handleStartCloseFunction()
      },
    )
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
  }

  handleStartCloseFunction () {
    this.closeTimeout = setTimeout(() => {
      this.handleClose()
    }, 4000)
  }

  handleStopCloseFunction () {
    clearTimeout(this.closeTimeout)
  }
}

if (!customElements.get('wishlist-toast-notification')) {
  customElements.define(
    'wishlist-toast-notification',
    WishlistToastNotification,
  )
}
